///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractDialogComponent } from '../../../dialog-manager/abstract-dialog.component';
import { CustomerRestrictionsService } from './customer-restrictions.service';
import { SuiCustomerRestrictionsDTO } from '../../../generated/shared-sui-types.model';

@Component({
    selector: 'winde-customer-restrictions-dialog-component',
    templateUrl: './customer-restrictions-dialog.component.html',
    styleUrls: ['./customer-restrictions.scss'],
    providers: [CustomerRestrictionsService],
    standalone: false
})
export class CustomerRestrictionsDialogComponent extends AbstractDialogComponent implements OnInit {
    public restrictions: SuiCustomerRestrictionsDTO;

    constructor(
        private readonly dialogRef: MatDialogRef<CustomerRestrictionsDialogComponent>,
        private readonly customerRestrictionsService: CustomerRestrictionsService
    ) {
        super();
    }

    ngOnInit(): void {
        this.customerRestrictionsService.query().subscribe((restrictions: SuiCustomerRestrictionsDTO) => {
            this.restrictions = restrictions;
            this.restrictions.adminUserLimit.isMandatory = true;
            this.restrictions.plannerUserLimit.isMandatory = true;
            this.restrictions.projectsLimit.isMandatory = true;
            this.restrictions.projectLocationsLimit.isMandatory = true;
        });
    }

    @HostListener('window:keydown.enter', ['$event'])
    onSave(event: KeyboardEvent): void {
        event.preventDefault();
        this.save();
    }

    save(): void {
        if (this.restrictions.validateAndShowError()) {
            this.customerRestrictionsService.update(this.restrictions).subscribe((result) => {
                if (result) {
                    this.dialogRef.close();
                }
            });
        }
    }
}
